/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Gesundheitszeugnisid2Inputs */



/**

* @param {_Field_Gesundheitszeugnisid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_gesundheitszeugnisid2 = /** @type {((inputs?: _Field_Gesundheitszeugnisid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Gesundheitszeugnisid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Gesundheitszeugnis")
});
export { _field_gesundheitszeugnisid2 as "_field_gesundheitszeugnisID" }